import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import IMEIDeviceRepairBlockData from '../../../Models/Content/IMEIDeviceRepairBlockData';
import IMEIDeviceRepairMain from './IMEIDeviceRepairMain';

export default class IMEIDeviceRepairBlock extends EpiComponent<IMEIDeviceRepairBlockData> {
  public render(): null | ReactNode | ReactNodeArray {
    return <IMEIDeviceRepairMain context={this.getContext()} contentData={this.props.data} />;
  }
}
